import AsyncStorage from "@react-native-async-storage/async-storage";

const MARKED_DATES_KEY = "markedDates";

export const SUCCESS_COLOR = "#1ABC9C";
export const RELAPSE_COLOR = "#E74C3C";

/**
 * @returns {string}
 */
export function getTodayDateKey() {
  return new Date().toISOString().split("T")[0];
}

/**
 * @returns {Promise<Record<string, unknown>>}
 */
export async function loadMarkedDatesRaw() {
  try {
    const saved = await AsyncStorage.getItem(MARKED_DATES_KEY);
    if (!saved) return {};
    const parsed = JSON.parse(saved);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

/**
 * @param {Record<string, unknown>} data
 */
export async function saveMarkedDatesRaw(data) {
  await AsyncStorage.setItem(MARKED_DATES_KEY, JSON.stringify(data));
}

/**
 * @param {Record<string, unknown>} entry
 * @param {string} status
 */
export function withStatusCalendarStyling(entry, status) {
  const out = {
    ...entry,
    status,
    selected: true,
    selectedColor: status === "success" ? SUCCESS_COLOR : status === "relapse" ? RELAPSE_COLOR : "#D1D5DB",
    note: typeof entry?.note === "string" ? entry.note : "",
  };
  if (status === "relapse") {
    out.marked = true;
    out.dotColor = RELAPSE_COLOR;
  }
  return out;
}

/**
 * @returns {'Morning'|'Afternoon'|'Evening'|'Night'}
 */
export function inferTimeOfDay() {
  const h = new Date().getHours();
  if (h < 12) return "Morning";
  if (h < 17) return "Afternoon";
  if (h < 21) return "Evening";
  return "Night";
}

/**
 * @param {Record<string, unknown>} dates
 * @param {string} dateKey
 */
export function applySuccessToMarkedDates(dates, dateKey) {
  const prev = dates?.[dateKey] ?? {};
  return {
    ...dates,
    [dateKey]: withStatusCalendarStyling({ ...prev }, "success"),
  };
}

/**
 * Marks fail from notification — streak resets; user adds trigger later in Notifications.
 *
 * @param {Record<string, unknown>} dates
 * @param {string} dateKey
 */
export function applyFailPendingToMarkedDates(dates, dateKey) {
  const prev = dates?.[dateKey] ?? {};
  return {
    ...dates,
    [dateKey]: withStatusCalendarStyling(
      {
        ...prev,
        relapse: {
          trigger: "",
          timeOfDay: inferTimeOfDay(),
          mood: 3,
          pendingDetails: true,
          fromNotification: true,
        },
      },
      "relapse",
    ),
  };
}
